import React, { Ref, useImperativeHandle, useRef } from 'react';
import { Button, Tippy } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { useMutation } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import ServiceCatalogModal from '../ServiceCatatlogModal';
import { ServiceCatalogItem } from '@nile/types';
import {
  AccountClient,
  CREATE_SERVICE_CATALOG,
  UPDATE_SERVICE_CATALOG
} from '@nile/graphql';
import { omit } from 'lodash';

type ServiceCatalogOptionsType = 'PRODUCT' | 'SERVICE' | 'PACKAGE';

function CreateServiceCatalogItemButton({
  reference,
  onSuccess
}: {
  reference?: Ref<{
    showForm: ({
      mode,
      catalogType,
      catalogItemId
    }: {
      mode: 'NEW' | 'EDIT' | 'CLONE';
      catalogType?: ServiceCatalogOptionsType;
      catalogItemId?: string;
    }) => void;
    hideForm: () => void;
  }>;
  onSuccess: (item) => void;
}) {
  const serviceCatalogFormRef = useRef<{
    showForm: ({
      mode,
      catalogType,
      catalogItemId
    }: {
      mode: 'NEW' | 'EDIT' | 'CLONE';
      catalogType?: ServiceCatalogOptionsType;
      catalogItemId?: string;
    }) => void;
    hideForm: () => void;
  }>(null);

  const CATALOGUE_OPTIONS: {
    key: ServiceCatalogOptionsType;
    icon: string;
  }[] = [
    { key: 'SERVICE', icon: 'ProjectIdentifier' },
    { key: 'PRODUCT', icon: 'Puzzle' }
    // { key: 'PACKAGE', icon: 'Box' }
  ];

  function handleSelect(key): void {
    serviceCatalogFormRef.current.showForm({
      mode: 'NEW',
      catalogType: key || 'SERVICE'
    });
  }

  useImperativeHandle(reference, () => {
    return {
      showForm: serviceCatalogFormRef?.current?.showForm,
      hideForm: serviceCatalogFormRef?.current?.hideForm
    };
  });

  const [CreateServiceCatalogItem] = useMutation(CREATE_SERVICE_CATALOG, {
    client: AccountClient
  });

  const [UpdateServiceCatalogItem] = useMutation(UPDATE_SERVICE_CATALOG, {
    client: AccountClient
    // onCompleted({ updateServiceCatalogItem }) {
    //   if (updateServiceCatalogItem) {
    //     setShowForm(false);
    //     refreshTable();
    //   }
    // }
  });

  function saveServiceCatalogItem(type: 'UPDATE' | 'CREATE') {
    return ({
      formData,
      createNew
    }: {
      formData: ServiceCatalogItem;
      createNew?: boolean;
    }): Promise<unknown> => {
      if (type === 'UPDATE') {
        return UpdateServiceCatalogItem({
          variables: {
            input: omit(formData, 'itemType')
          }
        }).then((res) => {
          serviceCatalogFormRef.current.hideForm();
          onSuccess(res?.data?.updateServiceCatalogItem);
        });
      } else {
        return CreateServiceCatalogItem({
          variables: {
            input: formData
          }
        }).then((res) => {
          serviceCatalogFormRef.current.hideForm();
          onSuccess(res?.data?.createServiceCatalogItem);
        });
      }
    };
  }

  return (
    <div>
      <ServiceCatalogModal
        hideAddNew
        reference={serviceCatalogFormRef}
        saveServiceCatalogItem={saveServiceCatalogItem}
      />
      <Tippy
        inertia
        delay={150}
        interactive
        theme="light"
        animation="shift"
        hideOnClick={true}
        animateFill={false}
        unmountHTMLWhenHide
        trigger="mouseenter"
        position="bottom-start"
        html={
          <div className="fx col g5 p5 br-5 border">
            {CATALOGUE_OPTIONS.map((option) => {
              const { key, icon } = option;
              return (
                <div
                  className="fx actr p5 ptr integration-filters"
                  key={key}
                  onClick={() => handleSelect(key)}
                >
                  <span className="fx actr mr-5">
                    <SVGIcon name={icon} size="sm" />
                  </span>
                  {key}
                </div>
              );
            })}
          </div>
        }
      >
        <Button icon={<SVGIcon name="Add" />}>
          <span className="fx actr g5">
            <FormattedMessage id="common.create" />
            <SVGIcon name="ArrowDown" />
          </span>
        </Button>
      </Tippy>
    </div>
  );
}

export default CreateServiceCatalogItemButton;
